/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JWTClaims
 */
export interface JWTClaims {
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    aud?: string;
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof JWTClaims
     */
    iat?: number;
    /**
     * 
     * @type {number}
     * @memberof JWTClaims
     */
    exp?: number;
    /**
     * 
     * @type {number}
     * @memberof JWTClaims
     */
    nbf?: number;
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    iss?: string;
    /**
     * 
     * @type {string}
     * @memberof JWTClaims
     */
    sub?: string;
}

/**
 * Check if a given object implements the JWTClaims interface.
 */
export function instanceOfJWTClaims(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JWTClaimsFromJSON(json: any): JWTClaims {
    return JWTClaimsFromJSONTyped(json, false);
}

export function JWTClaimsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JWTClaims {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aud': !exists(json, 'aud') ? undefined : json['aud'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'iat': !exists(json, 'iat') ? undefined : json['iat'],
        'exp': !exists(json, 'exp') ? undefined : json['exp'],
        'nbf': !exists(json, 'nbf') ? undefined : json['nbf'],
        'iss': !exists(json, 'iss') ? undefined : json['iss'],
        'sub': !exists(json, 'sub') ? undefined : json['sub'],
    };
}

export function JWTClaimsToJSON(value?: JWTClaims | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aud': value.aud,
        'id': value.id,
        'iat': value.iat,
        'exp': value.exp,
        'nbf': value.nbf,
        'iss': value.iss,
        'sub': value.sub,
    };
}

